<template>
  <div class="d-flex align-items-center justify-content-center mt-5">
    <div class="d-flex flex-column flex-sm-row" style="column-gap: 32px; row-gap: 18px">
      <div class="d-flex align-items-center" style="gap: 10px">
        <i class="fas fa-fire fa-3x" style="color: #d6b674;"></i>
        <div>
          <label class="text-muted mb-0">STREAK</label>
          <div style="color: #d6b674;">
            {{ streak }} DAY{{ streak !== 1 ? 'S' : '' }}
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap" style="gap: 8px">
        <div
            v-for="day in meditationDays"
            :key="day.date"
            class="text-center"
        >
          <div
              class="streak-dot d-flex align-items-center justify-content-center"
              :class="day.active ? 'streak-dot--active' : 'streak-dot--inactive'"
              :title="day.date"
          >
            <i v-if="day.active" class="fas fa-check streak-dot__check"></i>
          </div>
          <div class="streak-dot__label text-muted">{{ day.label }}</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import axios from "@/axios";

export default {
  name: "MeditationStreak",

  data() {
    return {
      streak: 0,
      meditationDays: [],
    }
  },
  methods: {
    meditationDateGet() {
      axios.get('dashboard/mediation-streak')
          .then((response) => {
            this.meditationDays = response.data.dates;
            this.streak = response.data.streak;
          });
    },
  },
  created() {
    this.meditationDateGet();
  }
}
</script>

<style scoped>
.streak-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.streak-dot--active {
  background-color: #d6b674;
}
.streak-dot--inactive {
  background-color: #e9ecef;
}
.streak-dot__check {
  color: white;
  font-size: 0.75rem;
}
.streak-dot__label {
  font-size: 0.6rem;
  margin-top: 2px;
}
</style>
